export default __webpack_public_path__ + "static/media/ticketinfo.d0b65f5c.svg";